<template>
  <div class="article-frame">
    <div ref="content" class="article-box article-box-bg">
      <img
        class="header-img"
        :src="$getThemeImagePath('useful_link/pc_banner_terms.png')"
      >

      <div class="content pos-relative">
        <go-to-top />
        <h1 class="main-title">
          {{ $t('Bao.terms_purple.title') }}
        </h1>
        <h2 class="update-time">
          {{ $t('Bao.terms_purple.updated_at') }}
        </h2>
        <ol class="terms-list">
          <div v-for="(article, key) in $t('Bao.terms_purple')" :key="key">
            <strong v-if="article.title">
              {{ article.title }}
            </strong>

            <div v-for="(block, bIndex) in article.blocks" :key="bIndex">
              <!-- 段落 -->
              <p v-if="block.type === 'paragraph'">
                {{ block.text }}
              </p>

              <!-- 清單 -->
              <ol v-else-if="block.type === 'list'">
                <li v-for="(item, i) in block.items" :key="i">
                  <!-- 純文字 -->
                  <template v-if="typeof item === 'string'">
                    <span class="nl2br">{{ item }}</span>
                  </template>

                  <!-- 含 link -->
                  <template v-else>
                    {{ item.text }}
                    <a :href="item.link.href" class="terms-email">
                      {{ item.link.text }}
                    </a>
                    {{ item.suffix }}
                  </template>
                </li>
              </ol>
            </div>
          </div>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'

export default {
  name: 'TermsPurple',
  components: {
    goToTop
  }
}
</script>
<style>
  .terms-email {
  color: #7b7b7b;
  text-decoration: underline;
  word-break: break-all;
}
.terms-list li {
	margin-bottom: 0rem;
}
.nl2br {
  white-space: pre-line;
}
</style>
